<rr-icon
  name="chevron-down"
  (click)="downActive == true ? downClick.emit() : null"
  class="active_{{ downActive }}"
></rr-icon>
<div class="line"></div>
<rr-icon
  name="chevron-up"
  (click)="upActive == true ? upClick.emit() : null"
  class="active_{{ upActive }}"
></rr-icon>
